<template>
  <div class="container">
    <router-view></router-view>
  </div>
</template>
<script>
export default {};
</script>
<style>
body {
  height: 100vh;
  margin: 0px;
  padding: 0px;
  background-color: #f3f3f4;
}
</style>
